import { useEffect } from 'react';
import { createSearchParams, useNavigate } from 'react-router';

import { useVirtualProvisioningContext } from '@perpay-web/fintech/hooks/useVirtualProvisioningContext';
import { paths } from '@perpay-web/fintech/props/appPaths';

const VirtualProvisioningRedirectNotification = ({ onNavigate }) => {
    const navigate = useNavigate();

    const { canAddPaymentPass } = useVirtualProvisioningContext();

    useEffect(() => {
        if (!canAddPaymentPass) {
            return;
        }

        onNavigate();

        navigate({
            pathname: paths.cardDetails.path,
            search: `?${createSearchParams({
                'add-to-wallet': 'open',
            })}`,
        });
    }, [navigate, canAddPaymentPass, onNavigate]);

    return null;
};

export default VirtualProvisioningRedirectNotification;
